// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`)
import * as changeCase from './changeCase';
import * as collection from './collection';
import * as componentStyle from './componentStyle';
import * as date from './date';
import * as element from './element';
import * as formatter from './formatter';
import * as globalStore from './globalStore';
import * as guid from './guid';
import * as intlInstanceCache from './intlInstanceCache';
import * as isArrayLike from './isArrayLike';
import * as isQueryOptionsObject from './isQueryOptionsObject';
import * as json from './json';
import * as layout from './layout';
import * as number from './number';
import * as object from './object';
import * as promise from './promise';
import * as rawComponentStyle from './rawComponentStyle';
import * as script from './script';
import * as transform from './transform';
import * as typeChecks from './typeChecks';
import * as url from './url';
// @endindex

import { isEmailValid } from './isEmailValid';
import { replacePlaceholders } from './replacePlaceholders';
import { replaceTextRecursive } from './replaceTextRecursive';
import { get } from './get';

export {
	// @index('./*', pp => `${pp.name},`)
	changeCase,
	collection,
	componentStyle,
	date,
	element,
	formatter,
	get,
	globalStore,
	guid,
	intlInstanceCache,
	isArrayLike,
	isQueryOptionsObject,
	json,
	layout,
	number,
	object,
	promise,
	rawComponentStyle,
	isEmailValid,
	replacePlaceholders,
	replaceTextRecursive,
	script,
	transform,
	typeChecks,
	url,
	// @endindex
};